import { gql } from '@apollo/client';

export const GET_RETURN_FEDEX_LABEL_URL = gql`
  query getReturnFedexLabelUrl($returnShippingUUID: String!) {
    getReturnFedexLabelUrl(returnShippingUUID: $returnShippingUUID)
  }
`;
